import { createMemoStyles } from '@wds/utils';

import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing }: PricingAppTheme) => ({
  Summary: {
    margin: [0, 'auto'],
  },
  PackagesContainer: {
    display: 'grid',
    padding: [0, spacing[3]],
    [MD_MEDIA_QUERY]: {
      display: 'flex',
      justifyContent: 'center',
      padding: 0,
    },
  },
}));
